<template>
  <div class="page_wrapper container-fluid off_campus_internship_area">
    <div class="row page_header off_campus_internship_header">
      <off-campus-internship-header />
    </div>
    <div class="row off_campus_internship_content">
      <off-campus-internship-content />
    </div>
  </div>
</template>

<script>
import OffCampusInternshipHeader from '~components/pages/off-campus-internship/OffCampusInternshipHeader'
import OffCampusInternshipContent from '~components/pages/off-campus-internship/OffCampusInternshipContent'
import '~style/pages/off_campus_internship.scss'
export default {
  name: 'OffCampusInternship',
  routerName: 'Off-campus-internship',
  components: {
    OffCampusInternshipHeader,
    OffCampusInternshipContent
  },
}
</script>




